import api from '../api'
import * as mutationTypes from './mutation-types'

const getters = {
  getReconciliationTextById: (state) => (id) => {
    return state.reconciliationTexts
      ? state.reconciliationTexts.find(
          (reconciliationText) => reconciliationText.id === id
        )
      : undefined
  },
  getReconciliationTextByPartnerId: (state) => (id) => {
    return state.reconciliationTexts
      ? state.reconciliationTexts.find(
          (reconciliationText) =>
            reconciliationText.partner_reconciliation_text_id === id
        )
      : undefined
  },
}

const mutations = {
  [mutationTypes.SET_RECONCILIATION_TEXTS](state, reconciliationTexts) {
    state.reconciliationTexts = reconciliationTexts
  },
  [mutationTypes.SET_RECONCILIATION_TEXTS_IDENTIFIERS](state, data) {
    state.reconciliationTextsFilterIdentifiers = {
      ...state.reconciliationTextsFilterIdentifiers,
      [data.reconciliationTextId]: [...data.insightsReconFilterIdentifiers],
    }
  },
}

const actions = {
  async fetchReconciliationTexts({ commit, state }) {
    // just fetch them once
    if (state.reconciliationTexts !== null) {
      return undefined
    }

    const reconciliationTexts = await api.fetchReconciliationTexts()

    commit(mutationTypes.SET_RECONCILIATION_TEXTS, reconciliationTexts)
  },
  fetchReconciliationTextsFilterIdentifiers({ commit }, reconciliationTextId) {
    const url =
      Silverfin.Routes.insights_recon_filter_identifiers_reconciliation_text_path(
        Silverfin.currentFirmId,
        reconciliationTextId
      )

    // eslint-disable-next-line camelcase
    window.$.getJSON(url).done((data) => {
      commit(mutationTypes.SET_RECONCILIATION_TEXTS_IDENTIFIERS, data)
    })
  },
}

export default {
  state() {
    return {
      reconciliationTexts: null,
      reconciliationTextsFilterIdentifiers: {},
    }
  },
  getters,
  mutations,
  actions,
}
